// extracted by mini-css-extract-plugin
export default {"input":"d--z","button":"e--z","selected":"f--z","unavailable":"g--z","oos":"h--z","image":"i--z","paperCutDisabledOverlay":"j--z"};